// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"9c7ce89b","453":"fe1afd58"}[chunkId] + ".chunk.js";
};